export const isLocalLiveParticipantPath = (path = "") =>
  /^\/local-live\/[^/]+\/participant\/[^/]+$/.test(path);

export const shouldSuppressNormalShellControls = ({
  isLocalLiveParticipantPage,
  shouldSuppressOuterAppChrome,
}) =>
  Boolean(isLocalLiveParticipantPage || shouldSuppressOuterAppChrome);

export const shouldRenderLocationSetupOnboarding = ({
  user,
  isAuthPage,
  isLocalLiveParticipantPage,
  shouldSuppressOuterAppChrome,
  showLocationPrompt,
}) =>
  Boolean(user) &&
  !isAuthPage &&
  !isLocalLiveParticipantPage &&
  !shouldSuppressOuterAppChrome &&
  showLocationPrompt;

export const shouldRenderEmailVerificationOnboarding = ({
  user,
  isAuthPage,
  isLocalLiveParticipantPage,
  shouldSuppressOuterAppChrome,
  profileLoading,
  shouldShowWarning,
}) =>
  Boolean(user?.uid) &&
  !isAuthPage &&
  !isLocalLiveParticipantPage &&
  !shouldSuppressOuterAppChrome &&
  !profileLoading &&
  shouldShowWarning();

export const shouldRenderNormalAppLoading = ({
  authLoading,
  profileLoading,
  isAdminRoute,
  isLocalLiveParticipantPage,
}) =>
  Boolean(authLoading || profileLoading) &&
  !isAdminRoute &&
  !isLocalLiveParticipantPage;
